import { Component, OnInit } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-home-footer',
  templateUrl: './home-footer.component.html',
  styleUrls: ['./home-footer.component.scss'],
})
export class HomeFooterComponent implements OnInit {
  currentYear = moment().year();

  constructor() {}

  ngOnInit(): void {}
}
